import { h } from 'preact';
import LoadingPulse from './LoadingPulse';

export default ({ onClick, modifierClass, isLoading }) => (isLoading ? (
  <LoadingPulse modifierClass={modifierClass} />
) : (
  <div className={`signin ${modifierClass}`}>
    <button className="signin-button" type="button" onClick={onClick}>
      <span className="signin-label">Iniciar sesión</span>
      <i className="badge-siempreplus" />
    </button>
  </div>
));



// WEBPACK FOOTER //
// ./components/SignInLink.js